import { SET_NOTES } from '../saga/dashboard';

const initialState = {
  list: []
};

const notes = (state = initialState, action) => {
  switch (action.type) {
    case SET_NOTES: {
      const { data } = action;

      return {
        ...state,
        list: data
      };
    }
    default: {
      return state;
    }
  }
};

export default notes;
